import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import CardGrid from "../../components/Card/CardGrid";
import CardSimple from "../../components/Card/CardSimple";
import Planning from "../../components/Planning/Planning";
import './Accueil.css';
import useRating from '../../hooks/useRating';
import {useModal} from "../../contexts/ModalContext";
import {
    getAccueilApi,
} from "../../services/SeanceService";
import {
    getSeancesPlanningApi,
    parseSeancesPlanning,
    parseSeancesPlanningCoach
} from "../../services/PlanningService";
import {useUser} from "../../contexts/UserContext";
import TitleSecondary from "../../components/Title/TitleSecondary";
import MyDonut from "../../components/Charts/MyDonut";
import SearchGlobal from "../../components/Search/SearchGlobal";
import Routing from "../../services/routing";

function AccueilPage() {
    const {user} = useUser();
    const [titre, setTitre] = useState('');
    const {showModal} = useModal();
    const [myStats, setMyStats] = useState([]);
    const [myPlanning, setMyPlanning] = useState([]);

    const [listCardsData, setlistCardsData] = useState([]);
    const navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const onRatingChange = () => {
        handleSuccess();
    };

    const [rating, handleRatingChange] = useRating(user?.lastSeance?.ratingValue, user?.lastSeance?.seanceId, onRatingChange);

    const handleLastRating = (rate, handleRatingChange) => {
        showModal('rating', {rate: rate, seance: user.lastSeance, onSaveRating: handleRatingChange});
    };

    const chargerDonnees = async (start, end) => {
        const response = await getSeancesPlanningApi(start, end);
        setMyPlanning(response.planning);
    };

    useEffect(() => {
        if (!user) return;

        // if (user.roles.includes("ROLE_ADMIN")) {
        //     navigate('/admin');
        // }

        setTitre("Bienvenu" + (user.civiliteFkId === 3 ? "e" : "") + ", " + user.prenom + " !"); // 3 = madame, 4 = monsieur

        if ((user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) && (user.lastSeance && user.lastSeance.rating === false && user.lastSeance.disableShowRatingModal === false)) {
            handleLastRating(rating, handleRatingChange);
        }

        (async () => {
            const getSeances = await getAccueilApi();
            if (getSeances.success === true) {
                setlistCardsData(getSeances.cardsData);
                setMyStats(getSeances.stats);
                setMyPlanning(getSeances.planning);
            } else {
                handleError("Une erreur est survenue : " + getSeances.msg);
            }
        })();

    }, [user]);

    function renderContentBasedOnRole() {
        if (!user) return null;

        const myPlanningDataParse = user.roles.includes("ROLE_COACH") ?
            parseSeancesPlanningCoach(myPlanning.seances, myPlanning.legend)
            : parseSeancesPlanning(myPlanning.seances, myPlanning.legend);

        if (user.roles.includes("ROLE_USER")) {
            return (
                <>
                    <div style={{margin: "20px 0 40px 0"}}>
                        <SearchGlobal placeholder={"Rechercher une activité"} onSearch={async (values) => {
                        }}/>
                    </div>
                    <Planning events={myPlanningDataParse.events} height={"250px"} legend={myPlanningDataParse.legend}
                              onDatesChange={chargerDonnees}/>
                </>
            );
        } else if (user.roles.includes("ROLE_COACH")) {
            return (
                <Planning events={myPlanningDataParse.events} height={"250px"} legend={myPlanningDataParse.legend}
                          onDatesChange={chargerDonnees}/>
            );
        } else if (user.roles.includes("ROLE_REFERENT")) {
            if (!myStats) return <p>Pas de données pour graphique</p>;
            return (
                <>
                    <div style={{margin: "20px 0 40px 0"}}>
                        <SearchGlobal placeholder={"Rechercher une activité"} onSearch={async (values) => {
                        }}/>
                    </div>

                    <div>
                        <Planning events={myPlanningDataParse.events} height={"250px"}
                                  legend={myPlanningDataParse.legend}
                                  onDatesChange={chargerDonnees}/>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            margin: "20px 0 40px 0"
                        }}>
                            <TitleSecondary text={"Vue d'ensemble"}/>
                            <MyDonut data={myStats.data} title={myStats.title} totalValue={myStats.totalUsers}/>
                            <Link to={Routing.routes.statsMain}>Voir plus</Link>
                        </div>
                    </div>
                </>
            );
        } else {
            return null;
        }
    }

    return (
        <div className="content">
            <TitleMain text={titre}/>

            {renderContentBasedOnRole()}

            <CardGrid cards={listCardsData} CardComponent={CardSimple}/>

        </div>
    )
}

export default AccueilPage;
